import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function PriceComparison() {
  return <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden my-10 font-sans" data-id="element-255">
      <div className="p-6 bg-gray-50 border-b border-gray-200" data-id="element-256">
        <h3 className="text-xl font-bold text-center text-gray-900" data-id="element-257">
          Comparons les options
        </h3>
      </div>
      <div className="divide-y divide-gray-100" data-id="element-258">
        <div className="p-4 md:p-6 flex items-start gap-4" data-id="element-259">
          <div className="mt-1 bg-red-100 p-1 rounded-full shrink-0" data-id="element-260">
            <XIcon className="w-4 h-4 text-red-600" data-id="element-261" />
          </div>
          <div data-id="element-262">
            <div className="font-bold text-gray-900" data-id="element-263">
              10 séances en institut
            </div>
            <div className="text-sm text-gray-500 mb-1" data-id="element-264">300 € à 500 €</div>
            <div className="text-sm text-gray-600" data-id="element-265">
              Douloureux, chronophage, résultats temporaires.
            </div>
          </div>
        </div>

        <div className="p-4 md:p-6 flex items-start gap-4" data-id="element-266">
          <div className="mt-1 bg-red-100 p-1 rounded-full shrink-0" data-id="element-267">
            <XIcon className="w-4 h-4 text-red-600" data-id="element-268" />
          </div>
          <div data-id="element-269">
            <div className="font-bold text-gray-900" data-id="element-270">
              6 mois de crèmes "premium"
            </div>
            <div className="text-sm text-gray-500 mb-1" data-id="element-271">150 € à 250 €</div>
            <div className="text-sm text-gray-600" data-id="element-272">
              Agit seulement en surface, résultats minimes.
            </div>
          </div>
        </div>

        <div className="p-4 md:p-6 flex items-start gap-4 bg-brand-50" data-id="element-273">
          <div className="mt-1 bg-brand-600 p-1 rounded-full shrink-0" data-id="element-274">
            <CheckIcon className="w-4 h-4 text-white" data-id="element-275" />
          </div>
          <div data-id="element-276">
            <div className="font-bold text-brand-900 text-lg" data-id="element-277">
              Lissea™ (Aujourd'hui)
            </div>
            <div className="text-brand-600 font-bold mb-1" data-id="element-278">
              80 € (Paiement unique)
            </div>
            <div className="text-sm text-brand-800" data-id="element-279">
              Indolore, 5 min/jour chez vous, appareil conservé à vie.
            </div>
          </div>
        </div>
      </div>
    </div>;
}